module.exports = __webpack_public_path__ + "img/document-types.86458136.png";